import React from 'react';
import { Box } from '@mui/material';
import { DModal, DPageLoader } from '../../../../../dum';
import { ExpenseDetailsChangeForm } from './expense-details-change-form';
import { useExpensesDialogQuery } from '../../../../../../services';

interface ISUpdateExpenseDetailsDialogProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    expenseId: number | null;
}

// "Editar datos opcionales" dialog for an expense — one of the two dialogs an
// expense has (the other being the full upsert). It fetches the expense fresh
// by id, reusing the full-upsert dialog query.
export function SUpdateExpenseDetailsDialog({
    open,
    setOpen,
    expenseId,
}: ISUpdateExpenseDetailsDialogProps) {
    const { data, loading } = useExpensesDialogQuery({
        skip: !expenseId || !open,
        variables: {
            ExpenseId: expenseId!,
        },
    });

    const expense =
        expenseId && data && data.getExpense && open
            ? data.getExpense
            : undefined;

    return (
        <DModal
            title={'Editar datos opcionales'}
            open={open}
            setOpen={setOpen}
        >
            {loading ? (
                <DPageLoader />
            ) : expenseId ? (
                <Box sx={{ p: 2 }}>
                    <ExpenseDetailsChangeForm
                        expenseId={expenseId}
                        currentNotes={expense?.notes}
                        currentExpectedPaymentDate={
                            expense?.expected_payment_date
                        }
                        currentRequireExternalCode={
                            expense?.require_external_code
                        }
                        currentExternalCode={expense?.external_code}
                        currentRequireSupplement={expense?.require_supplement}
                        currentSupplementCode={expense?.supplement_code}
                        currentReconciliationOnly={
                            expense?.reconciliation_only
                        }
                        currentIsDraft={expense?.is_draft}
                        currentCanceled={expense?.canceled}
                        onSuccess={() => setOpen(false)}
                    />
                </Box>
            ) : null}
        </DModal>
    );
}
